import { SuperModel } from './super-model.model';
import { EFsContentType } from './fs-item.enum';

export class Tag extends SuperModel {
  title: string;
  value: string;
  description: string;

  constructor(data: Partial<Tag> = {}) {
    super(data);

    if (data.value) {
      this.title = data.value;
    }
  }

  get serialised() {
    return {
      id: this.id,
      title: this.title,
      description: this.description,
    };
  }
}
